// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3cfLG","header":"PatientBlock_header__200mQ","label":"PatientBlock_label__3Fnm9","option":"PatientBlock_option__3CZtZ"};